import React from 'react';

const OperationComponentLoadable = React.lazy(() => import('./Operation/OperationDetail'));
const OperationTableComponentLoadable = React.lazy(() => import('../OperationComponent/OperationTableNew'));

export {
    OperationComponentLoadable,
    OperationTableComponentLoadable
};